package com.klantenstop.web.pages.authentication.login

import com.klantenstop.web.utils.MVI

interface LoginContract : MVI<LoginContract.State, LoginContract.Intent, LoginContract.Effect> {
    data class State(
        val hasAttemptedLogin: Boolean = false,
        val emailAddress: String = "",
        val password: String = ""
    ) {
        fun isValid(): Boolean {
            return emailAddress.isNotEmpty() && password.isNotEmpty()
        }
    }

    sealed class Intent {
        data object Login : Intent()
        data class UpdateEmail(val value: String) : Intent()
        data class UpdatePassword(val value: String) : Intent()
    }

    sealed class Effect {
        data object NavigateToNextScreen : Effect()
    }
}
